<template>
    <div class="app-container">
        <div class="div-align-lr page-top-but">
            <el-button type="primary" icon="el-icon-plus" @click.native="newAddpatrol">新增销售人员</el-button>

            <div style="width=250px"><el-input placeholder="请输入内容" v-model="searchPatrolVal" class="input-with-select">
                <el-select v-model="searchPatrolSelectVal" slot="prepend" placeholder="请选择">
                    <el-option label="人员id" value="username"></el-option>
                    <el-option label="姓名" value="realname"></el-option>
                    <el-option label="联系方式" value="tel"></el-option>
                    <el-option label="身份证号" value="idcard"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="onSearchPatrolBut"></el-button>
            </el-input></div>
        </div>

        <!-- 表格 -->
        <el-table :data="tableData" row-key="index" stripe style="width: 100%">
            <el-table-column align="" type="index" label="序号" width="100"> </el-table-column>
            <el-table-column align="cente" prop="username" label="销售ID" sortable> </el-table-column>
            <el-table-column align="center" prop="realname" label="销售姓名" sortable> </el-table-column>
            <el-table-column align="center" prop="tel" label="联系方式"> </el-table-column>
            <el-table-column align="center" prop="idcard" label="身份证" sortable> </el-table-column>
            <el-table-column align="center" prop="e_number" label="关联设备数"> </el-table-column>

            <el-table-column align="center" label="操作" width="100">
                <template slot-scope="scope">
                    <el-button @click="editTuserItme(scope.row),drawer = true" slot="reference" type="text" size="small" icon="el-icon-edit">编辑</el-button>
                    <el-button @click="handleClick(scope.row),drawer = true" slot="reference" type="text" size="small">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        
        <div v-if="pageData.total > pageData.per_page" class="pageWrap">
            <el-pagination background layout="prev, pager, next" :page-size="pageData.per_page" :total="pageData.total" @current-change="handleCurrentChange"></el-pagination>
        </div>

        <!--表单-->
        <el-dialog :title="addSaleTitle" :visible.sync="addSaleShow" :before-close="hideForm" width="1200px" top="5vh">
            <el-form :model="formData" :rules="formRules" ref="dataForm" label-width="150px">
                <el-form-item label="姓名：" prop="realname" style="width:90%">
                    <el-input v-model="formData.realname" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="手机号：" prop="tel" style="width:90%">
                    <el-input v-model="formData.tel" auto-complete="off" maxlength="11"></el-input>
                </el-form-item>
                <el-form-item label="身份证号：" prop="idcard" style="width:90%">
                    <el-input v-model="formData.idcard" auto-complete="off" maxlength="18"></el-input>
                </el-form-item>
                <el-form-item label="关联的设备：" :prop="addSaleType == 'add' ?'e_id':''" style="width:90%">
                    <el-select v-model="formData.e_id" multiple placeholder="请选择">
                        <el-option v-for="item in options" :key="item.id" :label="item.device_id" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <div class="butcss-item" v-if="equipment" label="已关联：" style="width:90%">
                    <span class="butcss" v-for="item in equipment" :key="item.id">
                        <el-button type="info" plain @click="delEquipment(item.id)">{{item.device_id}}<i class="el-icon-close el-icon--right"></i></el-button>
                    </span>
                </div>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading" style="width:200px">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {apiSUserlist,apiEditsUser,apiEditsUserSubmit,apiAddsUser,apiAddsUserSubmit} from "../../api/views/sale";

export default {
    components: {},
    data() {
        return {
            query:{
                id: "",
            },
            tableData: [],
            searchPatrolSelectVal: '',
            searchPatrolVal: '',
            addPatrolShow: false,

            addSaleShow: false,
            formLoading: false,
            addSaleType: 'add',
            addSaleTitle: '新增销售人员信息',
            formData: {
                "realname": "",//销售姓名
                "tel": "",//手机号码
                "idcard": "",//身份证
                "e_id":""//关联设备数据表id,id
            },
            formRules: {
                realname: [{ required: true, message: "请输入销售姓名", trigger: "blur" }],
                tel: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
                idcard: [{ required: true, message: "请输入身份证号", trigger: "blur" }],
                e_id:[{ required: true, message: "请选择关联设备", trigger: "blur" }]
            },
            options: [],
            equipment: [],
            pageData:{}
        }
    },
    mounted() {

    },
    created:function() {
        this.getList({page:1})
    },
    methods: {
        getList(page){
            const that = this
            apiSUserlist(page).then(res => {
                console.log(res)
                that.pageData = res
                console.log(that.pageData)
                that.tableData = res.data
                // console.log(this.tableData)
            }).catch(err => {
                console.log('获取列表-失败',err)
            })
        },
        onAddPatrolBoo(boo){
            console.log(boo)
            this.addPatrolShow = boo
        },
        onSearchPatrolBut(){
            console.log('搜索')
            this.query = {}
            this.query[this.searchPatrolSelectVal] = this.searchPatrolVal
            if(this.searchPatrolSelectVal && this.searchPatrolVal){
                this.getList(this.query)
                console.log(this.query)
            }else if(!this.searchPatrolSelectVal){
                this.$message({
                    message: '搜索类型不能为空',
                    type: "error"
                })
            }else if(!this.searchPatrolVal){
                this.$message({
                    message: '搜索内容不能为空',
                    type: "error"
                })
            }
        },
        handleClick(row){
            console.log('查看详情')
            this.$router.push({path:'details',query:{id:row.id}});
        },
        newAddpatrol(){
            console.log('新增销售人员')
            apiAddsUser().then(res => {
                console.log(res)
                this.options = res
                this.addSaleType = 'add'
                this.addSaleTitle = '新增销售人员信息'
            })
            this.addSaleShow = true

            // 清空验证信息表单
            if (this.$refs["dataForm"]) {
                this.$refs["dataForm"].clearValidate();
            }
        },
        delEquipment(id){
            const delid = id, equipment = this.equipment
            equipment.splice(equipment.findIndex(item => item.id === delid), 1)
            this.equipment = equipment
        },
        // 隐藏表单
        hideForm() {
            // 更改值
            this.addSaleShow = !this.addSaleShow;
            this.$emit("onChange",this.addSaleShow)
            this.formLoading = false
            this.options = []
            this.equipment = []
            // 清空表单
            this.$refs["dataForm"].resetFields();
            return true;
        },
        editTuserItme(row){
            const that = this, query = { id: row.id }
            // 清空验证信息表单
            if (this.$refs["dataForm"]) {
                this.$refs["dataForm"].clearValidate();
            }
            that.options = []
            that.equipment.e_id = []
            console.log(that.formData)
            apiEditsUser(query).then(res => {
                console.log(res)
                that.formData = res.user
                that.options = res.no_equipment
                that.equipment = res.equipment
                that.addSaleType = 'edit'
                that.addSaleTitle = '编辑个人信息'
                that.formData.e_id = []
            })
            this.addSaleShow = true
        },
        formSubmit() {
            const that = this
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    let _formData = JSON.parse(JSON.stringify(that.formData))
                    if(that.addSaleType == 'edit'){
                        console.log(_formData.e_id)
                        let formDataEid = _formData.e_id || []
                        for(let i of that.equipment) formDataEid.push(i.id)
                        _formData.e_id = formDataEid
                        console.log(formDataEid)
                        console.log(_formData.e_id)
                    }
                    _formData.e_id = _formData.e_id.toString()
                    let data = _formData
                    that.formLoading = true;
                    if(that.addSaleType == 'edit'){
                        apiEditsUserSubmit(data).then(response => {
                            this.formLoading = false;
                            console.log(response.code)
                            result(response)
                        })
                    }else{
                        apiAddsUserSubmit(data).then(response => {
                            this.formLoading = false;
                            console.log(response.code)
                            result(response)
                        })
                    }
                    function result(response){
                        if (response.code == 0) {
                            that.$message({
                                message: "操作成功",
                                type: "success"
                            });
                            // 刷新表单
                            that.$refs["dataForm"].resetFields();
                            that.addSaleShow = false;
                            that.getList(null)
                        } else {
                            that.$message({
                                message: response.message,
                                type: "error"
                            });
                        }
                    }
                }
            })
        },
        handleCurrentChange: function(currentPage){
            this.getList({page:currentPage})
        },
    }
};
</script>


<style>
  .el-input-group__prepend .el-select{
    width: 120px;
  }
    .page-top-but{
        padding:  20px;
    }
    .app-container h3.el-dialog__title {
        line-height: 24px;
        font-size: 18px;
        color: #303133;
    }
  .dialog-footer{
    text-align: center;
  }
  .addTeamUserBut{
      text-align: center;
      margin: 40px 0;
  }
  .butcss{
      display: inline-block;
      margin: auto 10px 10px auto;
  }
  .butcss-item{
      padding: 0 0 22px 150px;
  }
  .pageWrap{
      padding: 30px 0;
      text-align: center;
  }
</style>